if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      // Define element properties
      #formWrapper;
      #header;
      #stickyElement;
      #isVisible = false;
      #animation = null;
      #observer;
      #isAtBottom = false;
      #scrollHandler;

      constructor() {
        super();

        // Cache DOM elements
        this.#formWrapper = document.getElementById('product-form-wrapper');
        this.#header = document.getElementById('Header');
        // Das Sticky-Element ist der HTML-Inhalt innerhalb des Custom Elements
        this.#stickyElement = this.firstElementChild;

        // Vergib eine ID für das Sticky-Element
        this.#stickyElement.id = 'sticky-atc';
        
        // Stelle sicher, dass das Element fixed positioniert ist und einen hohen z-index hat
        this.#stickyElement.style.position = 'fixed';
        this.#stickyElement.style.zIndex = '9999';
        // Positioniere das Element in der linken unteren Ecke:
        this.#stickyElement.style.left = '20px';       // Abstand vom linken Bildschirmrand
        this.#stickyElement.style.bottom = '20px';     // Abstand vom unteren Bildschirmrand
        this.#stickyElement.style.right = 'auto';
        // Entferne den Transform, damit es nicht zusätzlich verschoben wird
        this.#stickyElement.style.transform = '';

        // Erstelle den gebundenen Scroll-Handler
        this.#scrollHandler = () => this.#handleScroll();
      }

      /**
       * Lifecycle: Wenn Element in den DOM eingefügt wird
       */
      connectedCallback() {
        // Verschiebe das Element, falls nötig, direkt in den Body, um eventuelle Stacking Contexts zu vermeiden
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }
        this.#setupObserver();
        window.addEventListener('scroll', this.#scrollHandler, { passive: true });
      }

      /**
       * Lifecycle: Wenn Element aus dem DOM entfernt wird
       */
      disconnectedCallback() {
        this.#observer?.disconnect();
        this.#animation?.cancel();
        window.removeEventListener('scroll', this.#scrollHandler);
      }

      /**
       * Initialisiert den Intersection Observer zur Beobachtung des Formulars
       */
      #setupObserver() {
        const options = {
          threshold: 0,
          rootMargin: '-100px'
        };

        this.#observer = new IntersectionObserver(
          this.#handleIntersect.bind(this),
          options
        );
        this.#observer.observe(this.#formWrapper);
      }

      /**
       * Handhabt Änderungen der Sichtbarkeit des Formulars
       */
      #handleIntersect(entries) {
        const [entry] = entries;
        const { bottom } = this.#formWrapper.getBoundingClientRect();
        const isFormAboveFold = bottom < 100;

        if (!entry.isIntersecting && isFormAboveFold) {
          this.#show();
        } else {
          this.#hide();
        }
      };

      /**
       * Blendet das Sticky-Element ein
       */
      #show() {
        if (this.#isVisible) return;
        this.#stickyElement.classList.remove('translate-y-full', 'opacity-0');
        this.#isVisible = true;
      }

      /**
       * Blendet das Sticky-Element aus
       */
      #hide() {
        if (!this.#isVisible) return;
        this.#stickyElement.classList.add('translate-y-full', 'opacity-0');
        this.#isVisible = false;
      }

      /**
       * Handhabt Scroll-Events
       */
      #handleScroll() {
        if (!this.#stickyElement) return;

        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const footerHeight = 200; // Ungefähre Footer-Höhe
        
        const isAtBottom = (windowHeight + scrollTop) >= (documentHeight - footerHeight);
        
        if (isAtBottom !== this.#isAtBottom) {
          this.#isAtBottom = isAtBottom;
          
          if (isAtBottom) {
            this.#hide();
          } else if (!this.#isVisible) {
            const { bottom } = this.#formWrapper.getBoundingClientRect();
            const isFormAboveFold = bottom < 100;
            if (isFormAboveFold) {
              this.#show();
            }
          }
        }
      }
    }
  );
}
